import React from 'react';
import { RelatedCardComponent } from '@shared/scenes/workflows/config';
import {
  isAuditTagComponent,
  isPersonComponent,
  isRelatedCardComponent,
  isSubformComponent,
  isTagComponent,
} from '@shared/scenes/workflows/utils';
import { DefaultPersonSelectionContainer } from './DefaultPersonSelectionContainer';
import { DefaultRelatedCardSelection } from './DefaultRelatedCardSelection';
import { DefaultSubformSelection } from './DefaultSubformSelection';
import { DefaultTagSelection } from './DefaultTagSelection';
import { useComponentDefaultRelatedCardSelectionHooks } from './hooks/DefaultRelatedCardSelectionHooks';

type Component = MBAPI.WorkflowTemplate_components;

interface Props {
  workflowTemplateId: string;
  component: Component;
  overridePath?: string;
}

export function DefaultSelection({ workflowTemplateId, component, overridePath }: Props) {
  if (isTagComponent(component)) {
    return <DefaultTagSelection component={component} overridePath={overridePath} />;
  }
  if (isAuditTagComponent(component)) {
    return <DefaultTagSelection component={component} overridePath={overridePath} />;
  }
  if (isPersonComponent(component)) {
    return <DefaultPersonSelectionContainer component={component} />;
  }
  if (isRelatedCardComponent(component)) {
    return (
      <RelatedCardHooksWrapper workflowTemplateId={workflowTemplateId} component={component} />
    );
  }
  if (isSubformComponent(component)) {
    return (
      <DefaultSubformSelection workflowTemplateId={workflowTemplateId} component={component} />
    );
  }
  return <></>;
}

function RelatedCardHooksWrapper({ component }: Props) {
  const relatedCardDefaultHooks = useComponentDefaultRelatedCardSelectionHooks(
    component as RelatedCardComponent,
  );
  return <DefaultRelatedCardSelection relatedCardDefaultHooks={relatedCardDefaultHooks} />;
}
